import { handle420 } from 'apis/HandleError';
import { checkStatus } from 'common/utils/helpers';
import { appConfig } from 'config';

/**
 *  fetchdata(url, options)
 *  -----------------------
 *  Expansion of the fetch function to retrieve data from the IBMS Cloud
 *
 * @module helpers
 * @method fetchdata
 * @param {url} url URL of the IBMS Cloud API server providing the data
 * @param {object} options Additional information to be provided in the body (e.g. method (GET, POST), body of the request, etc.)
 * @return {object} data from the Cloud as a nested object
 * @throws {Error} Currently thrown to the console only - need better Error handling
 *
 *  Note:
 *  -----
 *  This function is filling automatically the header with the proper header field, including the bearer token
 *  The private function _checkStatus(res) is needed to detail error cases if the response is not OK
 */
export const fetchdata = (url, options, retry = true, abortController) => {
  const auth = window.__APP_AUTH;
  let headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Origin: `${appConfig.webBaseUrl}/`,
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json',
    mode: 'cors'
  };

  return fetch(url, { ...options, headers: headers, signal: abortController?.signal })
    .then((res) => checkStatus(res))
    .then((res) => {
      return res.json();
    })
    .catch((e) => {
      console.log('fetch data error = ' + e.message);
      switch (e.message) {
        case '420':
          const auth = window.__APP_AUTH;
          if (auth && retry) {
            return auth
              .renewSession()
              .then(() => {
                return fetchdata(url, options, (retry = false));
              })
              .catch(() => {
                handle420();
              });
          } else {
            handle420();
          }
          break;
        default:
          throw e;
      }
      return;
    });
};
